module.exports = __webpack_public_path__ + "img/Ai-icon.eddea3d7.png";